import WithAutoTooltip from './WithAutoTooltip'

export default WithAutoTooltip
